mutation UnsubscribeChannel($subscriptionId: ID!) {
  result: StreamToolsUnsubscribeChannel(subscriptionId: $subscriptionId) {
    subscriptionId
    deleted
  }
}
